import { FormProvider, useWatch, yupResolver } from '@slal/ui/react-hook-form/core';
import { Field, RadioFieldGroup } from '@slal/ui/react-hook-form/fields';
import { Heading } from '@slal/ui/typography';
import { useNavigate } from 'react-router';
import { MaxWidthContent, Notice, StyledForm } from '~/components';
import { useApplicationForm } from '~/hooks';
import { adviceValidationSchema } from '~/schemas';
import { AdviceSchema, ApplicationFormKeys } from '~/types';
import { ApplicationButtons } from '../ApplicationButtons';
import { adviceOptions, adviceValues, initialValues } from './utils';

export const AdviceForm = () => {
    const { handleSubmit, form } = useApplicationForm<AdviceSchema>(
        {
            defaultValues: initialValues,
            resolver: yupResolver(adviceValidationSchema),
        },
        ApplicationFormKeys.ADVICE
    );

    const selectedAdvice = useWatch({
        control: form.control,
        name: 'advice.adviceReceived',
    });

    const navigate = useNavigate();
    const onValidCallback = () => navigate('/application/personal-information');

    const headingId = 'financial-adviser-help';
    const submitButtonLabel = 'Start application';

    return (
        <MaxWidthContent>
            <FormProvider {...form}>
                <StyledForm onSubmit={handleSubmit(onValidCallback, submitButtonLabel)} aria-labelledby={headingId}>
                    <Heading level={3} id={headingId}>
                        Have you received guidance?
                    </Heading>
                    <Field errorFor="advice.adviceReceived">
                        <RadioFieldGroup name="advice.adviceReceived" options={adviceOptions} stacked />
                    </Field>

                    {adviceValues.includes(selectedAdvice) && (
                        <Notice level="info">
                            If your circumstances have changed since you received guidance, consider making another
                            appointment.
                        </Notice>
                    )}
                    <ApplicationButtons continueContent={submitButtonLabel} backTo="/" />
                </StyledForm>
            </FormProvider>
        </MaxWidthContent>
    );
};
